







































































import Vue from 'vue';

export default Vue.extend({
  name: 'OctKpiCard',
  props: {
    tooltip: String,
    loading: Boolean,
    text: String,
    kpi: Number,
    color: String,
    darken: { type: String, required: false },
    target: String,
    filterProperty: String,
    filterValue: String,
    small: { type: Boolean, required: false }
  },
  data () {
    return {
      show: false,
      displayHelp: false
    };
  },
  computed: {
    cardTitleClasses() {
      return {
        small: this.small
      };
    },
    downloadEnabled (): boolean {
      return this.$store.getters['IS_SUPERADMIN'] || this.$store.getters['BROKER'] === 'LYNX';
    }
  },
  methods: {
    navigateTo(event: MouseEvent) {
      this.$router.push({ name: this.target, query: { [this.filterProperty]: this.filterValue } });
    },
    handleClickDownload(event: MouseEvent) {
      event.preventDefault();
      event.stopPropagation();

      this.$emit('download');
    }
  }
});
